import { render, staticRenderFns } from "./unionRefundDetail.vue?vue&type=template&id=0075cbe1&scoped=true"
import script from "./unionRefundDetail.vue?vue&type=script&lang=js"
export * from "./unionRefundDetail.vue?vue&type=script&lang=js"
import style0 from "./unionRefundDetail.vue?vue&type=style&index=0&id=0075cbe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0075cbe1",
  null
  
)

export default component.exports